import React from "react"

import { Button } from "@/components/ui/button"
import { DAY_NAMES, DAY_SHORT_LABELS } from "@/lib/collectionCoverage"
import { cn } from "@/lib/utils"
import { DayOfWeek } from "@/types/collections"

interface DayTogglesProps {
  value: DayOfWeek[]
  onChange: (days: DayOfWeek[]) => void
  compact?: boolean
}

/** Bulk-form day toggles in blue; a newly picked day goes on the end, not into week order. */
const DayToggles: React.FC<DayTogglesProps> = ({ value, onChange, compact = false }) => (
  <div className={cn("flex flex-wrap", compact ? "gap-1" : "gap-2")}>
    {DAY_NAMES.map((day) => {
      const selected = value.includes(day)
      return (
        <Button
          key={day}
          type="button"
          variant={selected ? "default" : "outline"}
          size="sm"
          onClick={() =>
            onChange(selected ? value.filter((d) => d !== day) : [...value, day])
          }
          className={
            compact
              ? cn("h-6 text-[10px] px-2", selected ? "bg-blue-600" : "")
              : cn("h-7 text-xs", selected ? "bg-blue-600 hover:bg-blue-700" : "")
          }
        >
          {DAY_SHORT_LABELS[day]}
        </Button>
      )
    })}
  </div>
)

export default DayToggles
